import React, { useState, useEffect, useRef, useCallback, Fragment } from "react";
import "@fontsource/poppins/400.css";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import debounce from "lodash.debounce";
import { TbRulerMeasure } from "react-icons/tb";
import ShareIcon from "./../../../src/assets/images/ShareIcon.png";

import { Alert, Snackbar, CircularProgress } from "@mui/material";
import { RiDeleteBin6Line } from "react-icons/ri";
import "../Properties/properties.css";
import { MdCheckBox, MdMapsHomeWork } from "react-icons/md";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";

import ShowerOutlinedIcon from "@mui/icons-material/ShowerOutlined";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import FeatureChipsContainer from "./FeatureChipsContainer";
import {
    appliancesArray,
    constructionArray,
    featuresArray,
    kitchenArray,
    materialsArray,
    moreFeatureArray,
    parkingArray,
} from "../utils/AminitiesArray";
import { BsCurrencyDollar } from "react-icons/bs";
import "../Header/Header.css";
import { getApi, putApi } from "../AppApis";
import { DiscardChangesModal } from "../../components/Modal/DiscardChangesModal";
import { IoMdAdd } from "react-icons/io";
import ShowingSettings from "./ShowingSettings";
import PictureManagement from "./PictureManagement";
import DeleteImageModal from "./DeleteImageModal";
import { FiEdit } from "react-icons/fi";
import InputForms from "./InputForms";
import GeoSearch from "../../components/PropertyComponent/GeoSearch";
import { toast } from "react-toastify";
import { PROPERTY_FIELD_LIMITS, validateBeds, validateBaths, validateGarages, validatePrice, validateLivingArea } from "../../config/propertyLimits";
const IMG_BASE_URL = config.get("IMAGE_BASE_URL");

const suggestions = [
    { value: "", label: "All" },
    { value: "Townhouse", label: "Townhouse" },
    { value: "Condo", label: "Condo" },
    { value: "Single_Family", label: "Single_Family" },
    { value: "Multifamily", label: "Multifamily" },
];

const EditProperty = ({
    property,
    setProperty,
    selectedProperty,
    properties,
    setIsShareModal,
    fetchProperties,
    setShowModal,
    setProperties,
    propertyCurrent,
}) => {
    const [editOption, setEditOption] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isDeleteModalShow, setIsDeleteModalShow] = useState(null);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const [isLocalImageSelected, setIsLocalImageSelected] = useState(false);
    const [showShowingSettings, setShowShowingSettings] = useState(false);
    const modalRef = useRef(null);
    const priceRef = useRef();
    const addressRef = useRef();
    const bedsRef = useRef();
    const bathRef = useRef();
    const sizeRef = useRef();
    const descriptionRef = useRef();
    const statusRef = useRef();
    const typeRef = useRef();
    const garage_sizeRef = useRef();
    const attached_garageRef = useRef();
    const garage_spacesRef = useRef();
    const car_portsRef = useRef();
    const full_bathroomsRef = useRef();
    const half_bathroomsRef = useRef();
    const mainDivRef = useRef();
    const nameRef = useRef();

    const homeType_ref = useRef();
    const [type_and_styles, setType_and_styles] = useState(property?.type_and_styles || []);
    const [showConfirm, setShowConfirm] = useState(false);
    const fileInputRef = useRef(null);
    const [imageFiles, setImageFiles] = useState(property?.images || []);
    const [editFirstGarage, setEditFirstGarage] = useState(false);
    const [editSecondGarage, setEditSecondGarage] = useState(false);
    const [isDynamicFieldsShow, setIsDynamicFieldsShow] = useState(false);
    const [appliances, setAppliances] = useState(appliancesArray);
    const [moreFeatures, setMoreFeatures] = useState(moreFeatureArray);
    const [selectedAppliances, setSelectedAppliances] = useState(property?.appliances);
    const [selectedFeature, setSelectedFeature] = useState(property?.features);
    const [features, setFeatures] = useState(featuresArray);
    const [kitchen, setKitchen] = useState(kitchenArray);
    const [selectedKitchen, setSelectedKitchen] = useState(property?.kitchen_features);
    const [parking, setParking] = useState(parkingArray);
    const [selectedParking, setSelectedParking] = useState(property?.ParkingFeatures);
    const [construction, setConstruction] = useState(constructionArray);
    const [selectedConstruction, setSelectedConstruction] = useState(property?.construction?.length > 0 ? property?.construction : []);
    const [materials, setMaterials] = useState(materialsArray);
    const [selectedMaterials, setSelectedMaterials] = useState(property?.materials || []);
    const [new_address, setNew_address] = useState(property?.address || "");
    const [selectedImages, setSelectedImages] = useState([]);
    const [latAndLng, setLatAndLng] = useState({
        latitude: property?.latitude || "",
        longitude: property?.longitude || "",
    });
    const [isApprovedVersion, setIsApprovedVersion] = useState(false);
    const [uploadingImages, setUploadingImages] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    // Handle modal close and refresh properties
    const handleModalClose = useCallback(() => {
        if (isDynamicFieldsShow) {
            setIsDynamicFieldsShow(false);
        } else {
            setShowModal(null);
            // Refresh properties list to show any newly uploaded images
            fetchProperties();
        }
    }, [isDynamicFieldsShow, fetchProperties]);

    useEffect(() => {
        if (propertyCurrent && !isApprovedVersion) {
            setProperty(propertyCurrent);
        }
    }, []);
    useEffect(() => {
        if (!property) return;
        setSelectedAppliances(property?.appliances || []);
        setSelectedFeature(property?.features || []);
        setSelectedKitchen(property?.kitchen_features || []);
        setSelectedParking(property?.ParkingFeatures || []);
        setSelectedConstruction(property?.construction?.length > 0 ? property?.construction : []);
        setSelectedMaterials(property?.materials || []);
        setImageFiles(property?.images || []);
        setType_and_styles(property?.type_and_styles || []);
        setNew_address(property?.address || "");
        setLatAndLng({
            latitude: property?.latitude || "",
            longitude: property?.longitude || "",
        });

        if (priceRef.current) priceRef.current.value = property?.price || "";
        if (bedsRef.current) bedsRef.current.value = property?.beds || "";
        if (bathRef.current) bathRef.current.value = property?.baths || "";
        if (sizeRef.current) sizeRef.current.value = property?.LivingArea || "";
        if (descriptionRef.current) descriptionRef.current.value = property?.description || "";
        if (statusRef.current) statusRef.current.value = property?.status || "";
        if (typeRef.current) typeRef.current.value = property?.type || "";
    }, [property]);

    useEffect(() => {
        const storiesFeature = features.find((feature) => feature.startsWith("stories{"));
        const patioPorchFeature = features.find((feature) => feature.startsWith("patioPorch{"));

        const storiesValue = storiesFeature ? parseInt(storiesFeature.split("{")[1].replace("}", "")) : "";
        const patioPorchValue = patioPorchFeature ? patioPorchFeature.split("{")[1].replace("}", "") : "";

        setProperty((prev) => ({
            ...prev,
            stories: storiesValue,
            patioPorch: patioPorchValue,
        }));

        const archStyleFeature = type_and_styles?.find((style) => style.startsWith("Architectural Style:"));
        const subtypeFeature = type_and_styles?.find((subtype) => subtype.startsWith("Property Subtype:"));

        const archStyleValue = archStyleFeature ? archStyleFeature.split(":")[1].trim() : "";
        const subtypeValue = subtypeFeature ? subtypeFeature.split(":")[1].trim() : "";

        setProperty((prev) => ({
            ...prev,
            selectedArchitecturalStyle: archStyleValue,
            selectedSubtype: subtypeValue,
        }));
    }, [features, type_and_styles]);

    const saveDebounced = useRef(
        debounce((updatedProperty, editOption) => {
            handleSubmit(updatedProperty, editOption, false);
        }, 800)
    ).current;

    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    const handleHomeTypeChange = (event) => {
        const { id, name, value } = event.target;
        const key = id || name;
        setProperty((prev) => ({
            ...prev,
            [key]: value,
        }));
        setEditOption((prev) => ({ ...prev, [key]: true }));
        setFilteredSuggestions(value ? suggestions.filter((item) => item.label.toLowerCase().includes(value.toLowerCase())) : suggestions);
    };

    const handleSelect = (suggestion) => {
        setProperty((prev) => ({
            ...prev,
            PropertySubType: suggestion.label,
        }));
        setEditOption((prev) => ({ ...prev, PropertySubType: true }));
        setFilteredSuggestions([]);
    };

    const handleEdit = (option) => {
        if (option === "address") {
        } else {
            setEditOption((prev) => ({
                ...prev,
                [option]: true,
            }));
        }
    };

    const handleSubmit = async () => {
        // Check for validation errors before submitting
        if (Object.keys(validationErrors).length > 0) {
            toast.error("Please fix validation errors before saving", { toastId: "validation-error" });
            return;
        }

        const formData = new FormData();

        const propertyData = {};

        // Helper function to safely convert to number
        const safeNumber = (value) => {
            if (value === "" || value === null || value === undefined) return null;
            const num = Number(value);
            return isNaN(num) ? null : num;
        };

        if (editOption.price) {
            const price = safeNumber(priceRef.current.value);
            if (price !== null) propertyData.price = price;
        }
        if (editOption.address) propertyData.address = new_address;
        if (editOption.beds) {
            const beds = safeNumber(bedsRef.current.value);
            if (beds !== null) propertyData.beds = beds;
        }
        if (editOption.baths) {
            const baths = safeNumber(bathRef.current.value);
            if (baths !== null) propertyData.baths = baths;
        }
        if (editOption.LivingArea) {
            const livingArea = safeNumber(sizeRef.current.value);
            if (livingArea !== null) propertyData.LivingArea = livingArea;
        }
        if (editOption.description) propertyData.description = descriptionRef.current.value;
        if (editOption.status) propertyData.status = statusRef.current.value;
        if (editOption.type) propertyData.type = typeRef.current.value;
        if (editOption.kitchen_features) propertyData.kitchen_features = Array.isArray(selectedKitchen) ? selectedKitchen : [];
        if (editOption.attached_garage) {
            const attachedGarage = safeNumber(attached_garageRef.current.value);
            if (attachedGarage !== null) propertyData.attached_garage = attachedGarage;
        }
        if (editOption.garage_spaces) {
            const garageSpaces = safeNumber(garage_spacesRef.current.value);
            if (garageSpaces !== null) propertyData.GarageSpaces = garageSpaces;
        }
        if (editOption.car_ports) {
            const carports = safeNumber(car_portsRef.current.value);
            if (carports !== null) propertyData.Carportspaces = carports;
        }
        if (editOption.garage_size) {
            const garageSize = safeNumber(garage_sizeRef.current.value);
            if (garageSize !== null) propertyData.garage_size = garageSize;
        }
        // if (editOption.built_in) propertyData.built_in = built_inRef.current.value;
        if (editOption.PropertySubType) propertyData.PropertySubType = homeType_ref.current.value;
        if (editOption.name) propertyData.name = nameRef.current.value;
        if (editOption.appliances) propertyData.appliances = Array.isArray(selectedAppliances) ? selectedAppliances : [];
        if (editOption.ParkingFeatures) propertyData.ParkingFeatures = Array.isArray(selectedParking) ? selectedParking : [];
        if (editOption.features) propertyData.features = Array.isArray(selectedFeature) ? selectedFeature : [];
        if (editOption.materials) propertyData.materials = Array.isArray(selectedMaterials) ? selectedMaterials : [];
        if (editOption.construction) propertyData.construction = Array.isArray(selectedConstruction) ? selectedConstruction : [];
        if (editOption.full_bathrooms) {
            const fullBathrooms = safeNumber(full_bathroomsRef.current.value);
            if (fullBathrooms !== null) propertyData.full_bathrooms = fullBathrooms;
        }
        if (editOption.half_bathrooms) {
            const halfBathrooms = safeNumber(half_bathroomsRef.current.value);
            if (halfBathrooms !== null) propertyData.half_bathrooms = halfBathrooms;
        }
        if (editOption.address && propertyData.address) {
            // Convert latitude and longitude to numbers with proper validation
            const lat = safeNumber(latAndLng.latitude);
            const lng = safeNumber(latAndLng.longitude);

            // Only include lat/lng if they are valid numbers
            if (lat !== null) propertyData.latitude = lat;
            if (lng !== null) propertyData.longitude = lng;
        }
        // Append the full object as a single JSON string
        formData.append("payload", JSON.stringify(propertyData));
        setEditFirstGarage(false);
        setEditSecondGarage(false);
        setEditOption({}); // Reset editing options

        const accessToken = localStorage.getItem("authUser");
        if (accessToken) {
            const token = accessToken.replace(/^"|"$/g, "");
            const propertyId = property?.property_id;

            if (!propertyId) {
                console.error("Property ID is missing");
                setMessage({ type: "error", message: "Property ID is missing. Please try again." });
                setShowSnackbar(true);
                return;
            }

            const REQ_URL = `${config.get("API_URL")}/properties/update_property_data/${propertyId}`;
            const REQ_GET_URL = `${config.get("API_URL")}/properties/get_property/${propertyId}`;
            try {
                setLoading(true);
                const response = await fetch(REQ_URL, {
                    method: "PUT",
                    headers: { Authorization: `Bearer ${token}` },
                    body: formData,
                });
                const jsonResponse = await response.json();
                if (jsonResponse?.detail) {
                    return toast.error(jsonResponse?.detail, { toastId: "error" });
                }
                if (!response.ok) {
                    throw new Error("Failed to update property");
                }
                fetchProperties();
                toast.success("Changes saved successfully.", { toastId: "success" });
                const updatedResponse = await fetch(REQ_GET_URL, {
                    method: "GET",
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (!updatedResponse.ok) {
                    throw new Error("Failed to fetch updated property data");
                }

                let updatedProp = await updatedResponse.json();
                updatedProp = updatedProp.current_property;
                const data = updatedProp?.images.map((item) => ({ ...item, image_url: `${IMG_BASE_URL}${item.image_url}` }));
                // Immediately update property state with new data including images
                setProperty(data);

                setProperties((prevProperties) => {
                    if (!Array.isArray(prevProperties)) {
                        return prevProperties;
                    }
                    return prevProperties.map((prop) => (prop.property_id === updatedProp.property_id ? updatedProp : prop));
                });

                setMessage({ type: "success", message: "Changes saved successfully." });
                setShowModal(false);
                setShowSnackbar(true);
                setImageFiles([]); // Clear new image files after successful upload
                fileInputRef.current.value = ""; // Clear file input
            } catch (error) {
                console.error("Error saving property:", error);
                setMessage({ type: "error", message: error.message || "Failed to save changes." });
                setShowSnackbar(true);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleClickOutside = useCallback(
        (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                // setShowModal(false);
            }
        },
        [setShowModal]
    );

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);

    const handleChange = (e) => {
        const { id, name, value } = e.target;

        const key = id || name;
        setProperty((prev) => ({
            ...prev,
            [key]: value,
        }));
        setEditOption((prev) => ({ ...prev, [key]: true }));
    };

    // Validation handler for numeric fields
    const handleNumericFieldChange = (e, validatorFn, fieldName) => {
        const { value } = e.target;

        // Allow empty values
        if (value === "") {
            setProperty((prev) => ({
                ...prev,
                [fieldName]: value,
            }));
            setValidationErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[fieldName];
                return newErrors;
            });
            setEditOption((prev) => ({ ...prev, [fieldName]: true }));
            return;
        }

        // Validate the value
        const validation = validatorFn(value);

        // Update property with the value (even if invalid, to show user input)
        setProperty((prev) => ({
            ...prev,
            [fieldName]: value,
        }));
        setEditOption((prev) => ({ ...prev, [fieldName]: true }));

        // Update validation errors
        if (!validation.isValid) {
            setValidationErrors((prev) => ({
                ...prev,
                [fieldName]: validation.error,
            }));
        } else {
            setValidationErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[fieldName];
                return newErrors;
            });
        }
    };

    useEffect(() => {
        return () => {
            saveDebounced.cancel();
        };
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Prevent the default action
            handleSubmit(); // Save changes
            setEditOption({}); // Exit edit mode
            setEditFirstGarage(false); // Exit edit mode for the first
            setEditSecondGarage(false);
        }
    };

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files); // Capture selected files
        if (files.length === 0) return;

        const newImageFiles = files.map((file, index) => ({
            file,
            previewUrl: URL.createObjectURL(file), // Generate a preview URL
            label: "", // Initialize with an empty label or any default value
            description: "",
            id: Date.now() + index,
            name: file.name,
            isUploading: true,
        }));

        // Add uploading placeholders immediately
        setUploadingImages(newImageFiles);
        setIsUploading(true);

        try {
            const formData = new FormData();
            newImageFiles.forEach((img) => {
                formData.append("images", img.file);
                formData.append("image_labels", img.label);
                formData.append("description", img.description);
                formData.append("name", img.name);
            });

            console.log("formData", newImageFiles);
            const response = await putApi(`/properties/update_property_data/${property?.property_id}`, formData, true);

            // Refresh the parent properties list first to get updated data
            await fetchProperties();

            // Fetch the full property data including pending version
            const newResponse = await getApi(`/properties/get_property/${property?.property_id}`);
            console.log("newResponse", { newResponse });

            const fullPropertyData = newResponse?.response?.data;
            const currentProperty = fullPropertyData?.current_property;
            const pendingVersion = fullPropertyData?.pending_version;

            if (currentProperty) {
                // If a pending version was created (happens when uploading to approved property)
                if (pendingVersion) {
                    // Switch to show the pending version with the newly uploaded images
                    setProperty(pendingVersion);
                    setImageFiles(pendingVersion?.images.map((item) => ({ ...item })));
                    setIsApprovedVersion(false);
                    toast.success("Images uploaded to pending version. Now showing pending version with your new images.", { toastId: "upload-success" });
                } else {
                    // No pending version, just update the current property
                    setImageFiles(currentProperty?.images.map((item) => ({ ...item })));
                    setProperty(currentProperty);
                    toast.success("Images uploaded successfully!", { toastId: "upload-success" });
                }
            }
        } catch (error) {
            console.error("Error uploading images:", error);
            toast.error("Failed to upload images. Please try again.", { toastId: "upload-error" });
        } finally {
            // Clear uploading states
            setUploadingImages([]);
            setIsUploading(false);
            // Clear file input
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };

    const handleRemoveImage = async (index, isNewImage = false) => {
        let filterLocalImages = selectedImages.filter((_, i) => _.preview);
        let filterDbImages = [...selectedImages];

        const imagesToUpload = filterDbImages.map((img) => {
            return { MediaKey: img };
        });
        try {
            const accessToken = localStorage.getItem("authUser");
            if (accessToken) {
                const token = accessToken.replace(/^"|"$/g, "");
                const apiUrl = config.get("API_URL"); // Get the base API URL from the config
                const removeUrl = `${apiUrl}/properties/remove_property_images`; // Complete endpoint URL

                const response = await fetch(removeUrl, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        property_id: property.property_id,
                        images: imagesToUpload,
                    }),
                });
                console.log("response", { response });
                if (!response.ok) {
                    const errorData = await response.json();
                    console.error("Failed to remove image:", response.status, errorData);
                    setMessage({ type: "error", message: `Failed to remove image: ${errorData.error || "Unknown error"}` });
                    setShowSnackbar(true);

                    return; // Stop further execution if there's an error
                }

                // remove filterDbImages from images
                console.log("filterDbImages", { imageFiles, filterDbImages });
                setImageFiles((prevImageFiles) => prevImageFiles.filter((img) => !filterDbImages.includes(img.MediaKey)));
                setSelectedImages([]); // Clear selected images after successful deletion
                setIsDeleteModalShow(false);
                fetchProperties();

                // Update state based on whether it's a new image or an existing one
                toast.success("Image deleted successfully.", { toastId: "success" });
                setShowSnackbar(true);
            } else {
                console.error("Access token not found.");
                setMessage({ type: "error", message: "Access token is missing." });
                setShowSnackbar(true);
            }
        } catch (error) {
            console.error("Error removing image:", error);
            setMessage({ type: "error", message: error.message || "Failed to remove image." });
            setShowSnackbar(true);
        }
    };

    return (
        <>
            {showConfirm && (
                <DiscardChangesModal
                    onCancel={() => {
                        setShowConfirm(false);
                    }}
                    onConfirm={() => setShowModal(false)}
                />
            )}
            {isDeleteModalShow && (
                <DeleteImageModal
                    onClose={() => setIsDeleteModalShow(false)}
                    isDeleteModalShow={isDeleteModalShow}
                    handleDelete={() => handleRemoveImage(selectedImageIndex, isLocalImageSelected)}
                    property={property}
                    setShowModal={setShowModal}
                    setSelectedImage={setSelectedImage}
                    selectedImage={selectedImage}
                    fetchProperties={fetchProperties}
                    setImageFiles={setImageFiles}
                    setProperties={setProperties}
                    properties={properties}
                />
            )}
            {selectedImage && (
                <PictureManagement
                    imageFiles={imageFiles}
                    property={property}
                    setImageFiles={setImageFiles}
                    setIsDeleteModalShow={setIsDeleteModalShow}
                    selectedImage={selectedImage}
                    onClose={() => {
                        fetchProperties();
                        setSelectedImage(null);
                    }}
                />
            )}
            <div className="tw-fixed  tw-z-[999] md:tw-z-[999] ">
                <div
                    onClick={(e) => e.stopPropagation()}
                    className="tw-fixed  tw-max-h-[95dvh] tw-inset-0 tw-z-30 tw-overflow-hidden tw-text-primary-500 tw-pb-10"
                >
                    <Snackbar open={showSnackbar} autoHideDuration={6000} onClose={() => setShowSnackbar(false)}>
                        <Alert
                            onClose={() => setShowSnackbar(false)}
                            severity={message.type === "success" ? "success" : "error"}
                            sx={{ width: "100%" }}
                        >
                            {message.message}
                        </Alert>
                    </Snackbar>
                    <header className="butounet tw-sticky -tw-top-[55px] md:tw-hidden tw-bg-tertiary tw-w-full tw-flex tw-py-4 tw-px-4 md:tw-px-10 tw-shadow-md tw-z-[1001] tw-p-0">
                        <button onClick={handleModalClose} className="backButton tw-w-fit gap-2 tw-bg-white tw-text-black">
                            <span>Back</span>
                        </button>
                        <h1 className="tw-font-space-grotesk tw-font-semibold tw-text-[18px] tw-text-white max-sm:tw-hidden">
                            <span style={{ textTransform: "uppercase" }}>AireB</span>rokers
                        </h1>
                        <nav className=" max-sm:tw-hidden">
                            <button className="backButton tw-gap-2 tw-bg-white tw-text-black" onClick={() => setIsShareModal(property)}>
                                <img loading="lazy" src={ShareIcon} className="buttonIcon " alt="" />

                                <span>Share</span>
                            </button>
                        </nav>
                    </header>
                    <div className="tw-fixed tw-top-0 md:tw-top-4 tw-left-1/2 tw-transform -tw-translate-x-1/2 tw-w-full md:tw-w-[90vw] tw-max-w-[1200px] tw-h-full md:tw-h-[90vh] tw-bg-background_color tw-overflow-y-auto tw-shadow-md tw-z-[1000]">
                        <header className="butounet tw-hidden  md:tw-sticky -tw-top-[55px] md:tw-top-0 tw-bg-tertiary tw-w-full md:tw-flex tw-py-4 tw-px-4 md:tw-px-10 tw-shadow-md tw-z-[1001] tw-p-0">
                            <button onClick={handleModalClose} className="backButton tw-w-fit gap-2 tw-bg-white tw-text-black">
                                <span>Back</span>
                            </button>
                            <h1 className="tw-font-space-grotesk tw-font-semibold tw-text-[18px] tw-text-white max-sm:tw-hidden">
                                <span style={{ textTransform: "uppercase" }}>OnMLS</span>
                            </h1>
                            <nav className=" max-sm:tw-hidden">
                                <button className="backButton tw-gap-2 tw-bg-white tw-text-black" onClick={() => setIsShareModal(property)}>
                                    <img loading="lazy" src={ShareIcon} className="buttonIcon " alt="" />

                                    <span>Share</span>
                                </button>
                            </nav>
                        </header>
                        <br />
                        {isDynamicFieldsShow ? (
                            <InputForms property={property} setIsDynamicFieldsShow={setIsDynamicFieldsShow} />
                        ) : (
                            <div className="tw-px-2 md:tw-px-5 tw-flex tw-flex-col ">
                                {propertyCurrent && (
                                    <div className="tw-flex tw-justify-between tw-mb-3">
                                        <p className="tw-text-black tw-text-[13px]">
                                            Your recent updates are currently under review. Once approved by our team, the changes will be reflected
                                            live. You can view your previously approved version below.{" "}
                                        </p>
                                        <button
                                            className="tw-underline tw-text-primary tw-text-[13px]"
                                            onClick={() => {
                                                setProperty(isApprovedVersion ? { ...propertyCurrent } : { ...selectedProperty });

                                                setIsApprovedVersion(!isApprovedVersion);
                                            }}
                                        >
                                            {isApprovedVersion ? "View Pending Version" : "View Approved Version"}
                                        </button>
                                    </div>
                                )}
                                <section className="tw-flex tw-rounded-lg tw-bg-white  tw-text-black tw-flex-col tw-gap-4 max-sm:tw-flex-wrap tw-w-full tw-p-2 md:tw-p-10">
                                    <div className="tw-flex  tw-gap-2 tw-justify-between tw-w-full tw-items-center">
                                        <h2 ref={mainDivRef} className="tw-text-[20px] tw-font-semibold">
                                            Property Pictures
                                        </h2>
                                        {selectedImages.length > 0 ? (
                                            <button
                                                onClick={() => setIsDeleteModalShow("image")}
                                                className="tw-flex tw-gap-2 tw-items-center tw-bg-[#EAEEF4] tw-rounded-md tw-py-2 tw-px-4 tw-text-black"
                                            >
                                                <RiDeleteBin6Line />
                                                <p>Delete</p>
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => setIsDeleteModalShow("property")}
                                                className="tw-flex tw-gap-2 tw-items-center tw-justify-center tw-border-[red] tw-border  tw-rounded-md tw-py-2 tw-px-4 tw-text-[red]"
                                            >
                                                Cancel Listing
                                            </button>
                                        )}
                                    </div>
                                    <div className=" tw-flex tw-gap-4 tw-flex-wrap">
                                        <div className="tw-w-full  ">
                                            {/* Image upload input and label */}
                                            <label
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                                htmlFor="image"
                                                className={`tw-cursor-pointer tw-text-black tw-flex tw-flex-col tw-gap-2 tw-items-center tw-border-2 tw-border-dashed tw-rounded-md tw-h-[200px] tw-w-full md:tw-w-[200px] tw-transition-all tw-duration-300 ${
                                                    isUploading ? "tw-border-primary tw-bg-primary-50" : "tw-border-black hover:tw-border-primary"
                                                }`}
                                            >
                                                {isUploading ? (
                                                    <>
                                                        <div className="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-b-2 tw-border-primary"></div>
                                                        <span className="tw-text-[12px] tw-font-normal tw-text-primary">Uploading...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <IoMdAdd className="tw-text-[32px]" />
                                                        <span className="tw-text-[12px] tw-font-normal">Add Image</span>
                                                    </>
                                                )}
                                            </label>
                                            <input
                                                ref={fileInputRef}
                                                disabled={loading || isUploading}
                                                className="disabled:tw-bg-gray-100 tw-mb-1 tw-rounded-md"
                                                type="file"
                                                accept=".png, .jpg, .jpeg"
                                                multiple
                                                hidden
                                                id="image"
                                                onChange={handleFileChange}
                                            />
                                        </div>

                                        <>
                                            {imageFiles.map((img, i) => (
                                                <div
                                                    key={`new-${i}`}
                                                    className="tw-relative tw-group tw-border tw-cursor-pointer tw-text-black tw-flex tw-flex-col tw-gap-2 tw-items-center tw-rounded-md tw-h-[200px] tw-w-[200px]"
                                                >
                                                    <img
                                                        src={img?.image_url}
                                                        className="tw-w-full tw-rounded-md tw-h-full tw-object-cover"
                                                        alt="Preview"
                                                    />

                                                    <button
                                                        className="tw-absolute tw-top-2 tw-right-8 tw-opacity-0 group-hover:tw-opacity-100 tw-transition tw-duration-200"
                                                        onClick={() => {
                                                            setSelectedImage(img);
                                                            setSelectedImageIndex(i);
                                                        }}
                                                    >
                                                        <FiEdit color="#000" size={20} />
                                                    </button>

                                                    <button
                                                        className={`tw-absolute tw-top-2 tw-right-2 tw-transition tw-duration-200 ${
                                                            selectedImages.length > 0 ? "tw-opacity-100" : "tw-opacity-0 group-hover:tw-opacity-100"
                                                        }`}
                                                        onClick={(e) => {
                                                            if (selectedImages.includes(img.MediaKey)) {
                                                                setSelectedImages(selectedImages.filter((i) => i !== img.MediaKey));
                                                            } else {
                                                                setSelectedImages([...selectedImages, img.MediaKey]);
                                                            }
                                                        }}
                                                    >
                                                        {selectedImages.includes(img.MediaKey) ? (
                                                            <MdCheckBox color="#000" size={20} />
                                                        ) : (
                                                            <div className="tw-bg-white border border-black tw-h-[20px] tw-w-[20px] tw-rounded-md" />
                                                        )}
                                                    </button>
                                                </div>
                                            ))}

                                            {/* Upload placeholders */}
                                            {uploadingImages.map((img, i) => (
                                                <div
                                                    key={`uploading-${img.id}`}
                                                    className="tw-relative tw-border tw-border-primary-300 tw-bg-primary-50 tw-rounded-md tw-h-[200px] tw-w-[200px] tw-overflow-hidden"
                                                >
                                                    {/* Preview image with overlay */}
                                                    <img
                                                        src={img.previewUrl}
                                                        className="tw-w-full tw-h-full tw-object-cover tw-opacity-60"
                                                        alt="Uploading preview"
                                                    />

                                                    {/* Loading overlay */}
                                                    <div className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-white tw-bg-opacity-80">
                                                        <div className="tw-animate-spin tw-rounded-full tw-h-10 tw-w-10 tw-border-b-2 tw-border-primary tw-mb-2"></div>
                                                        <span className="tw-text-xs tw-text-primary tw-font-medium">Uploading...</span>
                                                        <div className="tw-mt-2 tw-w-16 tw-h-1 tw-bg-gray-200 tw-rounded-full tw-overflow-hidden">
                                                            <div className="tw-h-full tw-bg-primary tw-animate-pulse tw-rounded-full"></div>
                                                        </div>
                                                    </div>

                                                    {/* File name */}
                                                    <div className="tw-absolute tw-bottom-2 tw-left-2 tw-right-2 tw-bg-black tw-bg-opacity-70 tw-text-white tw-text-xs tw-px-2 tw-py-1 tw-rounded tw-truncate">
                                                        {img.name}
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    </div>
                                </section>

                                <br />

                                <section className="tw-flex tw-flex-row tw-rounded-[10px] tw-gap-3 tw-bg-white tw-flex-wrap tw-items-center tw-justify-between tw-w-full tw-p-2 md:tw-p-10 ">
                                    <div className=" tw-flex tw-flex-col tw-gap-4 tw-w-full">
                                        <div className="tw-flex md:tw-flex-row tw-flex-col tw-justify-between md:tw-items-center tw-w-full">
                                            <h2 className="tw-text-[20px] tw-text-black tw-font-semibold">Property Description</h2>
                                            <div className="tw-flex  tw-gap-2 tw-mt-3 md:tw-mt-0">
                                                <button
                                                    onClick={() => setIsDynamicFieldsShow(true)}
                                                    className="tw-bg-primary md:tw-min-w-[200px] hover:tw-bg-primary_hover  tw-text-white tw-px-2 md:tw-px-[2rem] tw-py-2 tw-rounded-lg"
                                                >
                                                    Dynamic Fields
                                                </button>
                                                <button
                                                    onClick={() => setShowShowingSettings(true)}
                                                    className="tw-bg-primary md:tw-min-w-[200px] hover:tw-bg-primary_hover  tw-text-white tw-px-2 md:tw-px-[2rem] tw-py-2 tw-rounded-lg"
                                                >
                                                    Showing Settings
                                                </button>
                                            </div>
                                        </div>
                                        <div className="tw-flex tw-flex-col tw-gap-2">
                                            <div className="tw-flex max-lg:tw-justify-between  tw-flex-row max-md:tw-flex-wrap tw-w-full tw-gap-2 max-sm:tw-gap-[1px] max-sm:tw-flex-wrap">
                                                <div className="tw-w-full max-md:tw-w-[48%]">
                                                    <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Property Value</p>
                                                    <div className="tw-w-full tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px] tw-overflow-hidden tw-h-[52px]">
                                                        <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-items-center tw-bg-primary">
                                                            <BsCurrencyDollar className="tw-text-white" />
                                                        </div>
                                                        <input
                                                            disabled={loading}
                                                            ref={priceRef}
                                                            id="price"
                                                            type="number"
                                                            placeholder="Enter Property Value"
                                                            className=" tw-outline-none tw-px-2 tw-py-1 tw-text-[1rem] tw-bg-transparent tw-w-[90%] tw-h-full"
                                                            min={PROPERTY_FIELD_LIMITS.PRICE_MIN}
                                                            max={PROPERTY_FIELD_LIMITS.PRICE_MAX}
                                                            value={property.price || ""}
                                                            onChange={(e) => handleNumericFieldChange(e, validatePrice, "price")}
                                                            onKeyDown={handleKeyDown}
                                                            // onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    {validationErrors.price && (
                                                        <p className="tw-text-red-500 tw-text-[12px] tw-mt-1">{validationErrors.price}</p>
                                                    )}
                                                </div>
                                                <br />
                                                <div className="tw-w-full max-md:tw-w-[48%]">
                                                    <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Beds</p>
                                                    <div className="tw-w-full tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px] tw-overflow-hidden tw-h-[52px]">
                                                        <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-text-white tw-items-center tw-bg-primary">
                                                            <BedOutlinedIcon />
                                                        </div>
                                                        <input
                                                            disabled={loading}
                                                            ref={bedsRef}
                                                            id="beds"
                                                            defaultValue={property.beds || "0"}
                                                            type="number"
                                                            placeholder="Enter Beds"
                                                            min={PROPERTY_FIELD_LIMITS.BEDS_MIN}
                                                            max={PROPERTY_FIELD_LIMITS.BEDS_MAX}
                                                            className=" tw-outline-none tw-px-2 tw-py-1 tw-text-[1rem] tw-bg-transparent tw-w-[90%] tw-h-full"
                                                            onChange={(e) => handleNumericFieldChange(e, validateBeds, "beds")}
                                                            onKeyDown={handleKeyDown}
                                                            // onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    {validationErrors.beds && (
                                                        <p className="tw-text-red-500 tw-text-[12px] tw-mt-1">{validationErrors.beds}</p>
                                                    )}
                                                </div>
                                                <div className="tw-w-full max-md:tw-w-[48%]">
                                                    <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Baths</p>
                                                    <div className="tw-w-full  tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px] tw-overflow-hidden tw-h-[52px]">
                                                        <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-text-white tw-items-center tw-bg-primary">
                                                            <ShowerOutlinedIcon />
                                                        </div>
                                                        <input
                                                            disabled={loading}
                                                            ref={bathRef}
                                                            id="baths"
                                                            placeholder="Enter Baths"
                                                            defaultValue={property.baths || "0"}
                                                            type="number"
                                                            min={PROPERTY_FIELD_LIMITS.BATHS_MIN}
                                                            max={PROPERTY_FIELD_LIMITS.BATHS_MAX}
                                                            step={PROPERTY_FIELD_LIMITS.BATHS_STEP}
                                                            className=" tw-outline-none tw-px-2 tw-py-1 tw-text-[1rem] tw-bg-transparent tw-w-[90%] tw-h-full"
                                                            onChange={(e) => handleNumericFieldChange(e, validateBaths, "baths")}
                                                            onKeyDown={handleKeyDown}
                                                            // onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    {validationErrors.baths && (
                                                        <p className="tw-text-red-500 tw-text-[12px] tw-mt-1">{validationErrors.baths}</p>
                                                    )}
                                                </div>
                                                <div className="tw-w-full max-md:tw-w-[48%]">
                                                    <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Size</p>
                                                    <div className="tw-w-full  tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px] tw-overflow-hidden tw-h-[52px]">
                                                        <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-text-white tw-items-center tw-bg-primary">
                                                            <TbRulerMeasure />
                                                        </div>
                                                        <input
                                                            disabled={loading}
                                                            ref={sizeRef}
                                                            id="LivingArea"
                                                            placeholder="Enter Size"
                                                            type="number"
                                                            min={PROPERTY_FIELD_LIMITS.LIVING_AREA_MIN}
                                                            max={PROPERTY_FIELD_LIMITS.LIVING_AREA_MAX}
                                                            defaultValue={property.LivingArea}
                                                            className=" tw-outline-none tw-px-2 tw-py-1 tw-text-[1rem] tw-bg-transparent tw-w-[90%] tw-h-full"
                                                            onChange={(e) => handleNumericFieldChange(e, validateLivingArea, "LivingArea")}
                                                            onKeyDown={handleKeyDown}
                                                        />
                                                    </div>
                                                    {validationErrors.LivingArea && (
                                                        <p className="tw-text-red-500 tw-text-[12px] tw-mt-1">{validationErrors.LivingArea}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="tw-w-full">
                                                <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Address</p>
                                                <div className="tw-w-full  tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px] tw-overflow-hidden tw-h-[52px]">
                                                    <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-text-white tw-items-center tw-bg-primary">
                                                        <LocationOnIcon />
                                                    </div>

                                                    <GeoSearch
                                                        setLatAndLng={setLatAndLng}
                                                        address={new_address}
                                                        onBoundingBoxUpdate={(boundingBox, place) => {
                                                            setNew_address(place.formatted_address);
                                                            setEditOption((prev) => ({ ...prev, address: true }));
                                                        }}
                                                        deleteSearchLocation={() => {}}
                                                        isSimple={true}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => setFilteredSuggestions([])}
                                                className="tw-flex tw-flex-row tw-justify-between max-sm:tw-flex-wrap tw-w-full tw-gap-2"
                                            >
                                                <div className="tw-w-full max-md:tw-w-[48%]">
                                                    <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Home Type</p>
                                                    <div className="tw-relative tw-w-full  tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px]  tw-h-[52px]">
                                                        <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-text-white tw-rounded-tl-[10px] tw-rounded-bl-[10px] tw-items-center tw-bg-primary">
                                                            <MdMapsHomeWork />
                                                        </div>
                                                        <select
                                                            ref={homeType_ref}
                                                            id="PropertySubType"
                                                            value={property?.PropertySubType || "Single_Family"}
                                                            onChange={handleHomeTypeChange}
                                                            className="tw-outline-none tw-px-2 tw-py-1 tw-text-[1rem] tw-bg-transparent tw-w-full tw-h-full"
                                                        >
                                                            <option value="Single_Family">Single Family</option>
                                                            <option value="Condo/Townhome">Condo</option>
                                                            <option value="Lots_acres_forms">Lot / Acres / Forms</option>
                                                            <option value="Multifamily (2+ units)">Multi Family</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="tw-w-full max-md:tw-w-[48%]">
                                                    <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Garages</p>
                                                    <div className="tw-w-full  tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px] tw-overflow-hidden tw-h-[52px]">
                                                        <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-text-white tw-items-center tw-bg-primary">
                                                            <DirectionsCarFilledOutlinedIcon />
                                                        </div>
                                                        <input
                                                            // disabled={true}
                                                            ref={attached_garageRef}
                                                            id="attached_garage"
                                                            type="number"
                                                            placeholder="Garage Cars Spaces"
                                                            min={PROPERTY_FIELD_LIMITS.GARAGES_MIN}
                                                            max={PROPERTY_FIELD_LIMITS.GARAGES_MAX}
                                                            defaultValue={property.attached_garage}
                                                            className=" tw-outline-none tw-px-2 tw-py-1 tw-text-[1rem] tw-bg-transparent tw-w-[90%] tw-h-full"
                                                            onChange={(e) => handleNumericFieldChange(e, validateGarages, "attached_garage")}
                                                            onKeyDown={handleKeyDown}
                                                            // onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    {validationErrors.attached_garage && (
                                                        <p className="tw-text-red-500 tw-text-[12px] tw-mt-1">{validationErrors.attached_garage}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="tw-flex tw-flex-row tw-justify-between max-sm:tw-flex-wrap tw-w-full tw-gap-2">
                                                <div className="tw-w-full max-md:tw-w-[48%]">
                                                    <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Detached Garages</p>
                                                    <div className="tw-w-full  tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px] tw-overflow-hidden tw-h-[52px]">
                                                        <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-text-white tw-items-center tw-bg-primary">
                                                            <DirectionsCarFilledOutlinedIcon />
                                                        </div>
                                                        <input
                                                            // disabled={true}
                                                            ref={garage_spacesRef}
                                                            id="garage_spaces"
                                                            type="number"
                                                            placeholder="Detached Garages"
                                                            min={PROPERTY_FIELD_LIMITS.GARAGE_SPACES_MIN}
                                                            max={PROPERTY_FIELD_LIMITS.GARAGE_SPACES_MAX}
                                                            defaultValue={property.GarageSpaces}
                                                            className=" tw-outline-none tw-px-2 tw-py-1 tw-text-[1rem] tw-bg-transparent tw-w-[90%] tw-h-full"
                                                            onChange={(e) => handleNumericFieldChange(e, validateGarages, "garage_spaces")}
                                                            onKeyDown={handleKeyDown}
                                                            // onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    {validationErrors.garage_spaces && (
                                                        <p className="tw-text-red-500 tw-text-[12px] tw-mt-1">{validationErrors.garage_spaces}</p>
                                                    )}
                                                </div>
                                                <div className="tw-w-full max-md:tw-w-[48%]">
                                                    <p className="tw-text-black tw-text-[14px] tw-mb-2">Enter Carports</p>
                                                    <div className="tw-w-full  tw-flex tw-items-center tw-border tw-border-[lightgrey] tw-rounded-[10px] tw-overflow-hidden tw-h-[52px]">
                                                        <div className="tw-h-full tw-w-[40px] tw-flex tw-justify-center tw-text-white tw-items-center tw-bg-primary">
                                                            <DirectionsCarFilledOutlinedIcon />
                                                        </div>
                                                        <input
                                                            // disabled={true}
                                                            ref={car_portsRef}
                                                            id="car_ports"
                                                            type="number"
                                                            placeholder="Carports"
                                                            min={PROPERTY_FIELD_LIMITS.CARPORTS_MIN}
                                                            max={PROPERTY_FIELD_LIMITS.CARPORTS_MAX}
                                                            defaultValue={property.Carportspaces}
                                                            className=" tw-outline-none tw-px-2 tw-py-1 tw-text-[1rem] tw-bg-transparent tw-w-[90%] tw-h-full"
                                                            onChange={(e) => handleNumericFieldChange(e, validateGarages, "car_ports")}
                                                            onKeyDown={handleKeyDown}
                                                            // onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    {validationErrors.car_ports && (
                                                        <p className="tw-text-red-500 tw-text-[12px] tw-mt-1">{validationErrors.car_ports}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <section className="tw-text-gray-600">
                                        <h3 className="facts ">More Features</h3>
                                        <span className="text">(Choose the tags)</span>
                                        <FeatureChipsContainer
                                            array={moreFeatures}
                                            setArray={setMoreFeatures}
                                            handleEdit={handleEdit}
                                            setShowModal={setShowModal}
                                            selected={selectedFeature}
                                            setSelected={setSelectedFeature}
                                            name="features"
                                            tw-leading-none
                                            heading=""
                                        />
                                    </section>

                                    <div className="tw-flex tw-flex-row tw-justify-between tw-w-full tw-mt-3">
                                        <div className="tw-flex tw-justify-between tw-w-full">
                                            <h1 className="tw-font-[700] tw-text-[1.8rem] tw-flex tw-items-center tw-w-full">
                                                <div className="tw-w-full tw-flex tw-justify-between tw-flex-col tw-gap-4 tw-items-center">
                                                    <h2 className="tw-text-[20px] tw-text-black tw-font-semibold tw-text-start tw-w-full">
                                                        Property Description
                                                    </h2>
                                                    <textarea
                                                        ref={descriptionRef}
                                                        id="description"
                                                        className="EditDescr tw-w-full placeholder:tw-font-thin tw-bg-background_color tw-px-5 tw-py-5 tw-border tw-border-gray-300 tw-rounded-md tw-p-5"
                                                        value={property?.description}
                                                        onChange={handleChange}
                                                        placeholder="Write property description including facilities and information here..."
                                                        readOnly={!editOption.description}
                                                        disabled={loading}
                                                        onFocus={() => setEditOption((prev) => ({ ...prev, description: true }))}
                                                        onKeyDown={handleKeyDown}
                                                        // onBlur={handleBlur}
                                                    />
                                                </div>
                                            </h1>
                                        </div>
                                    </div>
                                </section>
                                <br />
                                <section className="tw-flex tw-flex-row tw-rounded-[10px] tw-gap-3 tw-mb-10 tw-bg-white tw-flex-wrap tw-items-center tw-justify-between tw-w-full tw-p-2 md:tw-p-10">
                                    <div className="tw-justify-between tw-w-full tw-mt-3">
                                        <section className="EditFactsFeatures">
                                            <h3 className="facts">More Details And Facts</h3>
                                            <br />
                                            <FeatureChipsContainer
                                                array={appliances}
                                                handleEdit={handleEdit}
                                                setArray={setAppliances}
                                                setShowModal={setShowModal}
                                                selected={selectedAppliances}
                                                setSelected={setSelectedAppliances}
                                                name="appliances"
                                                heading="Appliances"
                                            />
                                            <FeatureChipsContainer
                                                array={kitchen}
                                                setArray={setKitchen}
                                                setShowModal={setShowModal}
                                                selected={selectedKitchen}
                                                handleEdit={handleEdit}
                                                setSelected={setSelectedKitchen}
                                                name="kitchen_features"
                                                heading="Kitchen"
                                            />
                                            <FeatureChipsContainer
                                                array={parking}
                                                setArray={setParking}
                                                setShowModal={setShowModal}
                                                selected={selectedParking}
                                                handleEdit={handleEdit}
                                                setSelected={setSelectedParking}
                                                name={"ParkingFeatures"}
                                                heading="Parking"
                                            />
                                            <FeatureChipsContainer
                                                array={construction}
                                                setArray={setConstruction}
                                                setShowModal={setShowModal}
                                                selected={selectedConstruction}
                                                handleEdit={handleEdit}
                                                setSelected={setSelectedConstruction}
                                                name={"construction"}
                                                heading="Construction"
                                            />
                                            <FeatureChipsContainer
                                                array={materials}
                                                setArray={setMaterials}
                                                selected={selectedMaterials}
                                                setShowModal={setShowModal}
                                                handleEdit={handleEdit}
                                                setSelected={setSelectedMaterials}
                                                name={"materials"}
                                                heading="Materials"
                                            />{" "}
                                        </section>
                                    </div>

                                    <div className="tw-flex tw-justify-center tw-w-full max-sm:tw-flex-wrap  tw-items-center tw-gap-4 tw-mb-5 tw-mt-10">
                                        <button
                                            onClick={() => {
                                                setShowConfirm(true);
                                            }}
                                            className="tw-bg-[#fff] tw-min-w-[200px]  max-sm:tw-w-full tw-border tw-border-primary tw-text-primary hover:tw-border-secondary tw-px-5 tw-py-2 tw-rounded-lg"
                                            disabled={loading}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleSubmit}
                                            className="tw-bg-primary tw-min-w-[200px] hover:tw-bg-primary_hover max-sm:tw-w-full tw-text-white tw-px-2 md:tw-px-[5rem] tw-py-2 tw-rounded-lg"
                                        >
                                            {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save Listing "}
                                        </button>
                                    </div>
                                </section>
                            </div>
                        )}
                    </div>
                </div>

                {showShowingSettings && <ShowingSettings onClose={() => setShowShowingSettings(false)} property={property} />}
            </div>
        </>
    );
};

export default EditProperty;
